import React, { useState } from 'react'
import styles from './SignupBanner.module.scss'

export default function SignupBanner({ dark = false }) {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState('idle') // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email.trim()) return

    setStatus('loading')
    setErrorMsg('')

    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      })

      let data = {}
      try { data = await res.json() } catch { /* non-JSON response */ }

      if (res.ok) {
        setStatus('success')
      } else {
        setStatus('error')
        setErrorMsg(data.error || 'Something went wrong')
      }
    } catch {
      setStatus('error')
      setErrorMsg('Something went wrong — please try again')
    }
  }

  const bannerClass = [styles.banner, dark ? styles.bannerDark : ''].join(' ')

  if (status === 'success') {
    return (
      <div className={bannerClass}>
        <span className={styles.successMsg}>You're on the list.</span>
      </div>
    )
  }

  return (
    <div className={bannerClass}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <label className={styles.label} htmlFor="signup-email">
          Get notified when new templates and features drop
        </label>
        <div className={styles.inputRow}>
          <input
            id="signup-email"
            type="email"
            className={styles.input}
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={status === 'loading'}
            autoComplete="email"
          />
          <button
            type="submit"
            className={styles.button}
            disabled={status === 'loading' || !email.trim()}
          >
            {status === 'loading' ? 'Saving…' : 'Notify me'}
          </button>
        </div>
        {status === 'error' && (
          <div className={styles.errorMsg}>{errorMsg}</div>
        )}
      </form>
    </div>
  )
}
